import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { BlockProductGroupModel } from 'Pages/orders/blockProductGroup'
import { Callback } from 'Src/types/utilTypes'

interface BlockProductState {
	blockProducts: ResponseCatalog<BlockProductGroupModel>
	requestParams: RequestParams
	product: BlockProductGroupModel | null
	visibleDrawer: boolean
}

const blockProductInitialState: BlockProductState = {
	blockProducts: new ResponseCatalog<BlockProductGroupModel>(),
	requestParams: new RequestParams(),
	product: null,
	visibleDrawer: false,
}

export namespace BlockProductNS {
	export type GetBlockProductList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetBlockProductList = PayloadAction<ResponseCatalog<BlockProductGroupModel>>
	export type SetRequestParams = PayloadAction<RequestParams>

	export type SetBlockProduct = PayloadAction<BlockProductGroupModel | null>
	export type UpdateBlockProduct = PayloadAction<{
		data: BlockProductGroupModel
		id: number
	}>
	export type CreateBlockProduct = PayloadAction<BlockProductGroupModel>
	export type DeleteBlockProduct = PayloadAction<number>
	export type SetVisibleDrawer = PayloadAction<boolean>
}

export const blockProductSlice = createSlice({
	name: 'blockProduct',
	initialState: blockProductInitialState,
	reducers: {
		getAll: (state, action: BlockProductNS.GetBlockProductList) => {},
		setAll: (state, action: BlockProductNS.SetBlockProductList) => {
			state.blockProducts = action.payload
		},
		setRequestParams: (state, action: BlockProductNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.blockProducts = new ResponseCatalog<BlockProductGroupModel>()
			state.requestParams = new RequestParams()
			state.visibleDrawer = false
		},
		setOne: (state, action: BlockProductNS.SetBlockProduct) => {
			state.product = action.payload
		},
		updateOne: (state, action: BlockProductNS.UpdateBlockProduct) => {},
		createOne: (state, action: BlockProductNS.CreateBlockProduct) => {},
		deleteOne: (state, action: BlockProductNS.DeleteBlockProduct) => {},
		setVisibleDrawer: (state, action: BlockProductNS.SetVisibleDrawer) => {
			state.visibleDrawer = action.payload
		},
	},
})
